import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@qadra/frontend-common';
import getClientConfig from '../utils/clientConfig';
import { connect } from '@qadra/frontend-common/redux';
import { SpinnerLogo } from '@qadra/frontend-common/atoms';
import { useTranslate } from '@federico.moretti/react-translate';
import {
  ActionText,
  SPACINGS,
  useMediaQuery,
  useTheme,
} from '@qadra/frontend-common-ts';
import { paths } from '../utils';
import { ClientConfigContext } from '../contexts/ClientConfigContext';

const LayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0;
  background-color: ${(props) => (props.mobile ? 'white' : (props.bgColor || props.theme.colors.primary))};
  min-height: 100vh;
  height: 100vh;
`;

const InnerLayoutWrapper = styled.div`
  display: flex;
  /* margin: auto; */
  align-items: center;
  justify-content: center;
  width: 100%;
  flex-direction: column;
  background-color: ${(p) => (p.mobile ? 'white' : (p.bgColor || p.theme.colors.primary))}
`;

const Header = styled.div`
  display: flex;
  border-bottom: 1px solid ${(p) => (p.mobile ? p.theme.colors.primary : p.theme.colors.black)};
  height: ${(p) => (p.mobile ? 65 : 61)}px;
  background-color: ${(p) => (p.bgColor || p.theme.colors.primary)};

  & > .innerHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1200px;
    width: 100%;
    margin: auto;
    padding: 0 ${SPACINGS[4]};
    height: ${(p) => (p.mobile ? 65 : 61)}px;
  }
`;

function Menu({ Logo, bgColor }) {
  const { t } = useTranslate();
  const theme = useTheme();

  return (
    <Header bgColor={bgColor}>
      <div className="innerHeader">
        <div style={{ width: 109 }}>
          <Logo width={30} height={30} stroke={theme.colors.primary} />
        </div>
        {/*<ActionText*/}
        {/*  size="lg"*/}
        {/*  type="link-external"*/}
        {/*  target="_blank"*/}
        {/*  to={paths.qadra}*/}
        {/*  transform="none"*/}
        {/*  margin="none"*/}
        {/*>*/}
        {/*  {t('sso.visitQadra')}*/}
        {/*</ActionText>*/}
      </div>
    </Header>
  );
}

function MenuMobile({ Logo, bgColor }) {
  const { t } = useTranslate();
  const theme = useTheme();

  return (
    <Header mobile bgColor={bgColor}>
      <div className="innerHeader">
        <a href={paths.login}>
          <Logo width={30} height={30} stroke={theme.colors.primary} />
        </a>
      </div>
    </Header>
  );
}

function Layout(props) {
  const { children, spinnerState } = props;
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.mediaQueries.isMobile);

  const hostname = (typeof window !== 'undefined' && window.location && window.location.hostname) ? window.location.hostname : '';
  const { bgColor, Logo } = getClientConfig(hostname, theme);

  return (
    <ClientConfigContext.Provider value={{ bgColor, Logo }}>
      <LayoutWrapper bgColor={bgColor} mobile={isMobile}>
        <SpinnerLogo spinnerState={spinnerState} />
        {isMobile ? <MenuMobile Logo={Logo} bgColor={bgColor} /> : <Menu Logo={Logo} bgColor={bgColor} />}
        <InnerLayoutWrapper bgColor={bgColor} mobile={isMobile} style={{ paddingTop: isMobile ? '' : SPACINGS[16] }}>
          {children}
        </InnerLayoutWrapper>
      </LayoutWrapper>
    </ClientConfigContext.Provider>
  );
}

Layout.propTypes = {
  children: PropTypes.node,
  spinnerState: PropTypes.bool,
};

export default connect((state) => ({
  spinnerState: state.app.spinner.isSpinning,
}))(Layout);
